import { Injectable } from '@angular/core';
import { AuthToken } from './interfaces/token.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor() {}

  cacheToken(token: AuthToken) {
    localStorage.setItem('access_token', token.access_token);
    localStorage.setItem('refresh_token', token.refresh_token);
    localStorage.setItem('id_token', token.id_token);
  }

  getAccessToken(): string {
    return localStorage.getItem('access_token');
  }

  getRefreshToken(): string {
    return localStorage.getItem('refresh_token');
  }
  getIdToken(): string {
    return localStorage.getItem('id_token');
  }

  logout() {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  }
}
